import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanActivateFn, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';

import { CalService } from './cal.service';

@Injectable({
  providedIn: 'root'
})

class CalGuardService {
  private isLoggedIn: boolean = false;
  constructor(private cal: CalService, private router: Router) {
    this.cal.isUserLoggedIn().subscribe(result => {
      this.isLoggedIn = result;
    });
  }

  async canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Promise<boolean> {
    return await this.checkLogin();
  }

  private async checkLogin(): Promise<boolean> {
    if (this.isLoggedIn) {
      return this.isLoggedIn;
    }
    let valid = await this.cal.signIn();
    if (!valid) {
      this.router.navigate(['invalid-permission']);
    }
    return valid;
  }
}

export const CalAuthGuard: CanActivateFn = async (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) =>
  await inject(CalGuardService).canActivate(route, state);

